/* eslint-disable no-alert */
import React, { Component } from 'react'
import firebase from 'firebase/app'
import { Button } from 'semantic-ui-react'

export default class AddCategory extends Component {
  addMenu = async () => {
    try {
      const { fetchMenus } = this.props
      const prompt = window.prompt('What new menu should call?', '')

      if (prompt) {
        const updates = {}
        const menuKey = firebase
          .database()
          .ref('menus')
          .push().key

        updates[`/menus/${menuKey}`] = {
          name: prompt,
        }

        const err = await firebase
          .database()
          .ref()
          .update(updates)

        if (err) {
          alert(err)
        } else fetchMenus()
      }
    } catch (error) {
      alert(error)
    }
  }

  render() {
    return (
      <Button icon color="black" onClick={this.addMenu}>
        Add Menu
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/category/components/AddMenu.js